/*
 * Trophy Renderer Controller
 * @license Copyright 2018-2019 Spooorts Team, [search]² Interactive
 * 
 */

(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
			(factory((global.STROPHY = {})));
}(this, (function (exports) {
	'use strict';

	//
	// Init progress observer
	// ------------------------
	var loadingState = 0;
	var LObjects = null;

	//
	// Globals
	// ------------------------

	// Colors
	var colors = {
		"white": 0xffffff,
		"black": 0x000000,
		"lightgray": 0xfafafa,
		"gold": 0xd8b74c,
		"silver": 0xC0C0C0,
		"bronze": 0xcd7f32,
		"spooorts blue": 0x294f94
	}

	// Scheme
	var scene;
	var sceneHeight = window.innerHeight - 110;

	// Scene assets
	var camera, renderer, controls;
	var stats;

	// Reflection cameras
	var mirrorSphereCamera, skySphereCamera;

	// Renderer properties
	var maxAnisotropy;

	// Lights
	var ambient, lights = [];

	// Room
	var roomMesh;
	var shelfMesh;

	// Flags
	var debug = false;				// Debug mode
	var started = false;			// Started
	var inited = false;				// true = WebGL has been inited
	var texturesReady = false 	// true = Textures are ready to use
	var modelsReady = false;		// true = Models are ready!
	var reflectionUpdate = false; 	// Reflection is updating
	var blockedLoading = false;		// Flag for blocked model change (f.e. another loading in progress)
	var activeContainer;
	var activeLoader;
	var started = false;			// true = Everything is ready! 
	var dizzyCameraEnabled = true; 	// Controlls the dizzy camera
	var addFlag = 0;				// -1 = remove, 1 = add, 0 = nothing 
	var lastConfigChange;
	var waitTime = 300;				// amount of frames to wait
	var waitFrames = waitTime;		// wait time between for performance check
	var blockedLoading = false;	

	// Performance settings
	var hqGPUs = "(?=.*\\bNVIDIA|Intel|AMD\\b)";
	var GPUInfo = gpu.detect();
	var isHqGpu = multiSearchOr(GPUInfo.renderer, hqGPUs);
	var fps, fpsInterval, now, then, elapsed;
	var currentFPS = 0;
	var lowestFPS = 20;
	var targetFPS = 30;
	// Default model
	var defaultModel = "goldPokal";

	// Active model
	var currentModelName = "default_cup";
	var currentModelId=0;
	var activeTrophy;

	// Default model properties
	var defaultModelColorId = 0;
	var defaultStandMaterialId = 0;

	// Active model properties
	var activeModelColorId = 0;
	var activeModelColor = "gold";
	var activeStandMaterialId = 0;
	var activeStandMaterial = "redwood";

	// Active Texts
	var txtDisplayName = "";
	var txtDisplayEvtName = "";
	var txtDisplayStrecke = "";
	var txtDisplayZeit = "";
	var txtDisplayDatum = "";
	var txtDisplayPlatz = "";
	var txtDisplayResult = function () {
		var txt = "";
		if (txtDisplayStrecke && !txtDisplayZeit) {
			txt = txtDisplayStrecke;
		}

		if (!txtDisplayStrecke && txtDisplayZeit) {
			txt = txtDisplayZeit;
		}

		if (txtDisplayStrecke && txtDisplayZeit) {
			txt = txtDisplayStrecke + " in " + txtDisplayZeit;
		}

		return txt;
	};


	// Loading manager
	// -------------------------

	var manager = new THREE.LoadingManager();
	manager.onStart = function (url, itemsLoaded, itemsTotal) {
		blockedLoading = true;
		activeLoader = setTimeout(function () {
			document.querySelectorAll('.trophy-loader').forEach(function (item) {
				show(item);
			})
		}, 100);
		if (debug === true) {
			console.log('%cStarted loading file: ' + url + '.\nLoaded ' + itemsLoaded + ' of ' + itemsTotal + ' files.', 'color: #2196f3');
		}
	};

	manager.onLoad = function () {
		blockedLoading = false;
		if (debug === true) {
			console.log('%cLoading complete!', 'color: #2196f3');
		};

		if (started === true) {
			_showModel(activeTrophy.a);
		}

		modelsReady = true;

		clearTimeout(activeLoader);
		activeLoader = setTimeout(function () {
			_updateReflection();
			render();

			document.querySelectorAll('.trophy-loader').forEach(function (item) {
				hide(item);
			});
		}, 100);
	}

	manager.onProgress = function (url, itemsLoaded, itemsTotal) {
		loadingState += (1 / itemsTotal) / 2;
		if (debug === true) {
			console.log('%cLoading file: ' + url + '.\nLoaded ' + itemsLoaded + ' of ' + itemsTotal + ' files.', 'color: #2196f3');
		}
	};

	manager.onError = function (url) {
		console.log('%cThere was an error loading ' + url, 'color: #ff0000');
	};


	// Loaders
	// -------------------------

	// OBJ loader
	var OBJLoader = new THREE.OBJLoader(manager);

	// Texture loader
	var textureLoader = new THREE.TextureLoader();

	// Image loader
	var imageLoaders = [];


	//
	// Libraries
	// ------------------------------

	// Model library
	var TROPHIES;

	// Texture library
	var tlib = {
		"default_cup_outer": {
			raw: function (u, lib, key) {
				return new Promise(function (resolve, reject) {
					STROPHY_GT.Text(1024, 1024, {
						target: "body",
						datas: [{
							text: txtDisplayName
						},
						{
							text: txtDisplayEvtName
						},
						{
							text: txtDisplayResult()
						}]
					}, u, key).then(function (texture) {
						resolve(texture);
					});
				});
			},
			target: "default_cup_outer",
			model: "default_cup",
			properties: {
				wrap: "edge",
				rotation: -1.57,
				repeat: {
					x: 0.045,
					y: 0.045
				},
				offset: {
					x: 0.5,
					y: 0.58
				}
			},
			texture: []
		},
		"default_cup_plate": {
			raw: function (u, lib, key) {
				return new Promise(function (resolve, reject) {
					STROPHY_GT.Text(2048, 1024, {
						target: "plate",
						datas: [{
							text: txtDisplayPlatz
						},
						{
							text: txtDisplayDatum
						}]
					}, u, key).then(function (texture) {
						resolve(texture);
					});
				});
			},
			target: "default_cup_plate",
			model: "default_cup",
			properties: {
				wrap: "edge",
				rotation: 0,
				repeat: {
					x: 0.1,
					y: 0.2
				},
				offset: {
					x: 0.5,
					y: 0.45
				}
			},
			texture: []
		},
		"global_cup_outer": {
			raw: function (u, lib, key) {
				return new Promise(function (resolve, reject) {
					STROPHY_GT.Text(1024, 1024, {
						target: "body",
						datas: [{
							text: txtDisplayName
						},
						{
							text: txtDisplayEvtName
						},
						{
							text: txtDisplayResult()
						}]
					}, u, key).then(function (texture) {
						resolve(texture);
					});
				});
			},
			target: "global_cup_outer",
			model: "global_cup",
			properties: {
				wrap: "edge",
				rotation: -1.57,
				repeat: {
					x: 0.3,
					y: 0.3,
				},
				offset: {
					x: 0.5,
					y: 0.57
				}
			},
			texture: []
		},
		"global_cup_plate": {
			raw: function (u, lib, key) {
				return new Promise(function (resolve, reject) {
					STROPHY_GT.Text(2048, 1024, {
						target: "plate",
						datas: [{
							text: txtDisplayPlatz
						},
						{
							text: txtDisplayDatum
						}]
					}, u, key).then(function (texture) {
						resolve(texture);
					});
				});
			},
			target: "global_cup_plate",
			model: "global_cup",
			properties: {
				wrap: "edge",
				rotation: 0,
				repeat: {
					x: 0.5,
					y: 1
				},
				offset: {
					x: 0.5,
					y: 0.45
				}
			},
			texture: []
		},

		"default_medal_text": {
			raw: function (u, lib, key) {
				return new Promise(function (resolve, reject) {
					STROPHY_GT.Text(1024, 1024, {
						target: "body",
						datas: [{
							text: txtDisplayName
						},
						{
							text: txtDisplayEvtName
						},
						{
							text: txtDisplayPlatz
						},
						{
							text: txtDisplayDatum
						}]
					}, u, key).then(function (texture) {
						resolve(texture);
					});
				});
			},
			target: "default_medal_text",
			model: "default_medal",
			properties: {
				wrap: "edge",
				rotation: 3.13,
				repeat: {
					x: 0.3,
					y: 0.3
				},
				offset: {
					x: 0.5,
					y: 0.45
				}
			},
			texture: []
		},

		"hannover_medal_text": {
			raw: function (u, lib, key) {
				return new Promise(function (resolve, reject) {
					STROPHY_GT.Text(1024, 1024, {
						target: "body",
						datas: [{
							text: txtDisplayName
						},
						{
							text: txtDisplayPlatz
						}]
					}, u, key).then(function (texture) {
						resolve(texture);
					});
				});
			},
			target: "hannover_medal_bottom",
			model: "hannover_medal",
			properties: {
				wrap: "edge",
				rotation: 3.14,
				repeat: {
					x: 0.25,
					y: 0.25
				},
				offset: {
					x: 0.5,
					y: 0.72
				}
			},
			texture: []
		},

		"hannover_logo": {
			raw: function (u, lib, key) {
				return new Promise(function (resolve, reject) {
					STROPHY_GT.Image(512, 512, "assets/trophy/textures/marathon-hannover-logo.png", u, key).then(function (texture) {
						resolve(texture);
					});
				});
			},
			target: "medal_beam",
			model: "hannover_medal",
			properties: {
				wrap: "edge",
				rotation: 3.14,
				repeat: {
					x: 0.5,
					y: 0.5
				},
				offset: {
					x: 0.29,
					y: 0.51
				}
			},
			texture: []
		},

		"hannover_image": {
			raw: function (u, lib, key) {
				return new Promise(function (resolve, reject) {
					STROPHY_GT.Image(1024, 512, "assets/trophy/textures/hannover_medal_texture.png", u, key).then(function (texture) {
						resolve(texture);
					});
				});
			},
			target: "hannover_medal_top",
			model: "hannover_medal",
			properties: {
				wrap: "edge",
				rotation: 3.14,
				repeat: {
					x: 0.44,
					y: 0.85
				},
				offset: {
					x: 0.5,
					y: -0.1
				}
			},
			texture: []
		},

		"default_cert_text": {
			raw: function (u, lib, key) {
				return new Promise(function (resolve, reject) {
					STROPHY_GT.CertImage("assets/trophy/textures/paper-texture-2.jpg", 1024, 1024, txtDisplayName, txtDisplayEvtName, txtDisplayPlatz, txtDisplayDatum).then(function (texture) {
						resolve(texture);
					});
				});
			},
			target: "default_cert_text",
			model: "default_cert",
			properties: {
				wrap: "edge",
				rotation: 1.57,
				repeat: {
					x: 0.0242,
					y: 0.0242
				},
				offset: {
					x: 0.5,
					y: 0.45
				}
			},
			texture: []
		},
		"default_lasvegas_img":{
				raw: function (u, lib, key) {
					return new Promise(function (resolve, reject) {
						 STROPHY_GT.Image(2048, 2048, "assets/trophy/textures/lasvegas-medal.png", u,key ).then(function (texture) {
							resolve(texture);
						});
					});	
				},
			target: "default_lasvegas_img",
			model: "default_lasvegas",
			properties: { 
				wrap: "edge",  
				rotation: 0, 
				repeat: { x: 0.3, y: 0.215 }, 
				offset: { x: 0.345, y: 0.425 }
			},
			texture: [],
		},
		"default_antarctic_img":{
			raw: function (u, lib, key) {
				return new Promise(function (resolve, reject) {
					STROPHY_GT.Image(1024, 1024, "assets/trophy/textures/antarctic-medal-medal.png", u, key).then(function (texture) {
							resolve(texture);
						});
				});
			},
			target: "default_antarctic_img",
			model: "default_antarctic",
			properties: { 
				wrap: "edge",  
				rotation: 3.12, 
				repeat: { x: 0.35, y: 0.32 },  //0.32 0.26
				offset: { x: 0.5, y: 0.5 }
			},
			texture: [],
		},
		"default_losangeles_img":{
			raw: function (u, lib, key) {
				return new Promise(function (resolve, reject) {
					STROPHY_GT.Image(2048, 2048, "assets/trophy/textures/los-angeles.png", u, key).then(function (texture) {
						resolve(texture);
					});
				});
			},
			target: "default_losangeles_img",
			model: "default_losangeles",
			properties: { 
				wrap: "edge",  
				rotation: 3.14, 
				repeat: { x: 0.1, y: 0.07 }, 
				offset: { x: 0.5, y: 0.5 },
			},
			texture: [],
		},
		"default_paris_img":{
			raw: function (u, lib, key) {
				return new Promise(function (resolve, reject) {
					STROPHY_GT.Image(2048, 2048, "assets/trophy/textures/paris-medal.png", u, key).then(function (texture) {
						resolve(texture);
					});
				});
			},
			target: "default_paris_img",
			model: "default_paris_img",
			properties: { 
				wrap: "edge",  
				rotation: 0, 
				repeat: { x: 0.52, y: 0.52}, 
				offset: { x: 0.24, y: 0.3 },
			},
			texture: [],
		},
		"default_greatwall_img":{
			raw: function (u, lib, key) {
				return new Promise(function (resolve, reject) {
					STROPHY_GT.Image(2048, 2048, "assets/trophy/textures/greatwall-medal.png", u, key).then(function (texture) {
						resolve(texture);
					
					});
				});
			},
			target: "default_greatwall_img",
			model: "default_greatwall",
			properties: { 
				wrap: "edge",  
				rotation: 0, 
				repeat: { x: 0.16, y: 0.12 }, 
				offset: { x: 0.42, y: 0.44 },
			},
			texture: [],
		},
		"default_newyork_img":{
			raw: function (u, lib, key) {
				return new Promise(function (resolve, reject) {
					STROPHY_GT.Image(2048, 2048, "assets/trophy/textures/newyork-medal.png", u, key).then(function (texture) {
						resolve(texture);
					});
				});
			},
			target: "default_newyork_img",
			model: "default_newyork",
			properties: { 
				wrap: "edge",  
				rotation: 0, 
				repeat: { x: 0.147, y: 0.2 }, 
				offset: { x: 0.428, y: 0.387 },
			},
			texture: [],
		},
		"default_plate_text":{
			raw: function (u, lib, key) {
				return new Promise(function (resolve, reject) {
					STROPHY_GT.Text(2048, 2048, {
						target: "medal-lv",
						datas: [{
							text: txtDisplayName
						},
						{
							text: txtDisplayEvtName
						},
						{
							text: txtDisplayPlatz
						},
						{
							text: txtDisplayDatum
						},{text: txtDisplayResult()}]
					}, u, key).then(function (texture) {
						resolve(texture);
					});
				});
			},
			target: "default_plate_text",
			model: "default_lasvegas",
			properties: { 
				wrap: "edge",  
				rotation: 0, 
				repeat:{x:1.1, y:0.66},
				offset: { x: -0.05, y: 0.06 },

			},
			texture: [],
		},
		"default_plate_text_p":{
			raw: function (u, lib, key) {
				return new Promise(function (resolve, reject) {
					STROPHY_GT.Text(2048, 2048, {
						target: "medal-p",
						datas: [{
							text: txtDisplayName
						},
						{
							text: txtDisplayEvtName
						},
						{
							text: txtDisplayPlatz
						},
						{
							text: txtDisplayDatum
						},
						{text: txtDisplayResult()}]
					}, u, key).then(function (texture) {
						resolve(texture);
					});
				});
			},
			target: "default_plate_text_p",
			model:  "default_paris",
			properties: { 
				wrap: "edge",  
				rotation: 0, 
				repeat:{x:1.0, y:0.57},
				offset: { x: 0.01, y: 0.1 },

			},
			texture: [],
		},
		"default_plate_text_a":{
			raw: function (u, lib, key) {
				return new Promise(function (resolve, reject) {
					STROPHY_GT.Text(2048, 2048, {
						target: "medal-p",
						datas: [{
							text: txtDisplayName
						},
						{
							text: txtDisplayEvtName
						},
						{
							text: txtDisplayPlatz
						},
						{
							text: txtDisplayDatum
						},
						{text: txtDisplayResult()}]
					}, u, key).then(function (texture) {
						resolve(texture);
					});
				});
			},
			target: "default_plate_text_a",
			model: "default_antarctic",
			properties: { 
				wrap: "edge",  
				rotation: 0, 
				repeat:{x:0.9, y:0.57},
				offset: { x: 0.05, y: 0.1 },

			},
			texture: [],
		},
		"default_plate_text_g":{
			raw: function (u, lib, key) {
				return new Promise(function (resolve, reject) {
					STROPHY_GT.Text(2048, 2048, {
						target: "medal-p",
						datas: [{
							text: txtDisplayName
						},
						{
							text: txtDisplayEvtName
						},
						{
							text: txtDisplayPlatz
						},
						{
							text: txtDisplayDatum
						},
						{text: txtDisplayResult()}]
					}, u, key).then(function (texture) {
						resolve(texture);
					});
				});
			},
			target: "default_plate_text_g",
			model: "default_greatwall",
			properties: { 
				wrap: "edge",  
				rotation: 0, 
				repeat:{x:0.9, y:0.57},
				offset: { x: 0.05, y: 0.1 },

			},
			texture: [],
		},
		"default_plate_text_ny":{
			raw: function (u, lib, key) {
				return new Promise(function (resolve, reject) {
					STROPHY_GT.Text(2048, 2048, {
						target: "medal-p",
						datas: [{
							text: txtDisplayName
						},
						{
							text: txtDisplayEvtName
						},
						{
							text: txtDisplayPlatz
						},
						{
							text: txtDisplayDatum
						},
						{text: txtDisplayResult()}]
					}, u, key).then(function (texture) {
						resolve(texture);
					});
				});
			},
			target: "default_plate_text_ny",
			model:  "default_newyork",
			properties: { 
				wrap: "edge",  
				rotation: 0, 
				repeat:{x:0.9, y:0.57},
				offset: { x: 0.05, y: 0.1 },

			},
			texture: [],
		},
		"default_plate_text_la":{
			raw: function (u, lib, key) {
				return new Promise(function (resolve, reject) {
					STROPHY_GT.Text(2048, 2048, {
						target: "medal-p",
						datas: [{
							text: txtDisplayName
						},
						{
							text: txtDisplayEvtName
						},
						{
							text: txtDisplayPlatz
						},
						{
							text: txtDisplayDatum
						},
						{text: txtDisplayResult()}]
					}, u, key).then(function (texture) {
						resolve(texture);
					});
				});
			},
			target: "default_plate_text_la",
			model:"default_losangeles",
			properties: { 
				wrap: "edge",  
				rotation: 0, 
				repeat:{x:0.9, y:0.57},
				offset: { x: 0.05, y: 0.1 },

			},
			texture: [],
		},
		"redwood_raw": {
			raw: null,
			properties: {
				wrap: "repeat",
				rotation: 0,
				repeat: {
					x: 0.1,
					y: 0.1
				},
				offset: {
					x: 0,
					y: 0
				}
			},
			texture: textureLoader.load("assets/trophy/textures/redwood.jpg")
		},

		"dark_marble": {
			raw: null,
			properties: {
				wrap: "repeat",
				rotation: 0,
				repeat: {
					x: 0.1,
					y: 0.1
				},
				offset: {
					x: 0,
					y: 0
				}
			},
			texture: textureLoader.load("assets/trophy/textures/black-marble-texture.jpg")
		},

		"white_marble": {
			raw: null,
			properties: {
				wrap: "repeat",
				rotation: 0,
				repeat: {
					x: 0.1,
					y: 0.1
				},
				offset: {
					x: 0,
					y: 0
				}
			},
			texture: textureLoader.load("assets/trophy/textures/white-marble-texture.jpg")
		},
		"shelf_texture": {
			raw: null,
			properties: {
				wrap: "repeat",
				rotation: 0,
				repeat: {
					x: 6,
					y: 6
				},
				offset: {
					x: 0,
					y: 0
				}
			},
			texture: textureLoader.load("assets/trophy/textures/wood-texture-3.jpg")
		}
	};

	// Material library
	var mlib = {
		"metal_gold": {
			type: "standard",
			properies: { color: colors["gold"], bumpScale: 0.002, roughness: 0.1, metalness: 0.9, side: THREE.FrontSide }
		},
		"metal_silver": {
			type: "standard",
			properies: { color: colors["silver"], bumpScale: 0.002, roughness: 0.1, metalness: 0.9, side: THREE.FrontSide }
		},
		"metal_bronze": {
			type: "standard",
			properies: { color: colors["bronze"], bumpScale: 0.002, roughness: 0.1, metalness: 0.9, side: THREE.FrontSide }
		},
		"metal": {
			type: "standard",
			properies: { color: colors[activeModelColor], bumpScale: 0.002, roughness: 0.1, metalness: 0.9, side: THREE.FrontSide }
		},
		"metal_matte": {
			type: "standard",
			properies: { color: colors[activeModelColor], bumpScale: 0.002, roughness: 0.3, metalness: 0.7, side: THREE.FrontSide }
		},
		"paper": {
			type: "standard",
			properies: { color: colors["white"], roughness: 1, metalness: 0, side: THREE.FrontSide }
		},
		"redwood": {
			type: "standard",
			properies: { color: colors["white"], roughness: 0.5, metalness: 0.5, map: tlib["redwood_raw"].texture, side: THREE.FrontSide }
		},
		"shiny_black": {
			type: "standard",
			properies: { color: colors["black"], roughness: 0, metalness: 1, side: THREE.FrontSide }
		},
		"blue_glass": {
			type: "basic",
			properies: { color: colors["spooorts blue"], opacity: 0.5, transparent: true }
		},
		"dark_marble": {
			type: "standard",
			properies: { color: colors["white"], roughness: 0.5, metalness: 0.5, map: tlib["dark_marble"].texture, side: THREE.FrontSide }
		},
		"white_marble": {
			type: "standard",
			properies: { color: colors["white"], roughness: 0.5, metalness: 0.5, map: tlib["white_marble"].texture, side: THREE.FrontSide }
		},
		"white":{
			type:"standard",
			properies: { color: colors["white"],bumpScale: 0.004, roughness: 0.3, metalness: 0.9, side: THREE.FrontSide }
		},
		"metal_silver_custom": {
			type: "standard",
			properies: { color: colors["silver"], bumpScale: 0.006, roughness: 0.3, metalness: 0.7, side: THREE.FrontSide }
		},
		"black": {
			type: "standard",
			properies: { color: colors["black"], bumpScale: 0.003, roughness: 0.3, metalness: 0.7, side: THREE.FrontSide }
		},
	};


	// Set variables
	// --------------------------------

	var _setVariables = function (trophyDatas, callback) {
		// Default model
		defaultModel = trophyDatas.trophyType ?trophyDatas.trophyType:"Pokal Gold";

		// Default model properties
		defaultModelColorId = parseInt(trophyDatas?.trophyColor) - 1 || 0;
		defaultStandMaterialId = parseInt(trophyDatas?.trophyMaterial) - 1 || 0;

		// Translate property IDs to array keys
		_changeModelColor(defaultModelColorId, false);
		_changeStand(defaultStandMaterialId, false);

		activeModelColorId = defaultModelColorId;
		activeStandMaterialId = defaultStandMaterialId;

		// Active Texts
		txtDisplayName = trophyDatas.athleteName;
		txtDisplayEvtName = trophyDatas.eventName;
		txtDisplayStrecke = trophyDatas.hasStrecke === true ? trophyDatas.distance : "";
		txtDisplayZeit = trophyDatas.hasZeit === true ? trophyDatas.time : "";
		txtDisplayDatum = trophyDatas.hasDatum === true ? trophyDatas.formatedDate : "";

		if (typeof trophyDatas.platz !== 'undefined' && trophyDatas.hasPlatz === true && trophyDatas.time !== 'undefined') {
			txtDisplayPlatz = trophyDatas.platz + ". Platz";
		} else {
			txtDisplayPlatz = ""
		}

		if (trophyDatas?.trophyType.toUpperCase().includes("MEDAL")) {
			txtDisplayPlatz += " in " + trophyDatas.time;
		}

		// Default material color
		mlib["metal"].properies.color = colors[activeModelColor];

		if (typeof callback === "function") {
			return callback();
		}
	}
	function loadSprite(ctx, src, s) {
		var deferred = $.Deferred();
		var sprite = new Image();
		sprite.setIdx = s;

		// Callback function
		// 
		// Place logos into canvas
		sprite.onload = function() {
			var maxSize = 512;
			var sizes = resizeWallImage(this.width, this.height);
			var x = 0;
			var y = 0;


			if(this.setIdx < 6) {
				if(sizes["width"] < maxSize) {
					x = (this.setIdx * maxSize) + (this.setIdx * 148) + 148 + ((maxSize - sizes["width"]) / 2 );
				} else {
					x = (this.setIdx * sizes["width"]) + (this.setIdx * 148) + 148;
				}
			} else {
				if(sizes["width"] < maxSize) {
					x = ((this.setIdx - 6) * maxSize) + ((this.setIdx - 6) * 148) + 148 + ((maxSize - sizes["width"]) / 2 );
				} else {
					x = ((this.setIdx - 6) * sizes["width"]) + ((this.setIdx - 6) * 148) + 148;
				}
			}


			if(this.setIdx < 6) {
				if(sizes["height"] < maxSize) {
					y = maxSize / 2 - sizes["height"] / 2;
				}
			} else {
				if(sizes["height"] < maxSize) {
					y = (maxSize / 2 - sizes["height"] / 2) + maxSize;
				} else {
					y = maxSize;
				}
			}

			ctx.drawImage(this, x, y, sizes["width"], sizes["height"]);

			deferred.resolve();
		};
		sprite.src = src;
		return deferred.promise();
	}
	// FPS Controller
	// -------------------------

	function startAnimating(fps) {
		fpsInterval = 1000 / fps;
		then = Date.now();
		animate();
	}
	// Window resize
	// --------------------------------

	var _onWindowResize = function () {
		camera.aspect = window.innerWidth / sceneHeight;
		camera.updateProjectionMatrix();
		renderer.setSize(window.innerWidth, sceneHeight);
		setTimeout(function () {
			_updateReflection();
			render();
		}, 100);
	}


	//
	// Initialize
	// ------------------------

	// Enviroment
	var _init = function () {

		// Setup camera
		// -------------------------

		camera = new THREE.PerspectiveCamera(45, window.innerWidth / sceneHeight, 0.1, 1000);

		camera.position.set(0, 4.2, 3.7); 
		// Movements
		camera.movements = {
			speed: {
				x: 0.010578922301016692,
				y: 0.016502540152286232,
				z: 0.016992688568898
			},
			position: {
				x: 0.32421433453164683,
				y: 0.7704991432791928,
				z: 0.7316826193214969
			}
		}
		// Setup the renderer
		// -------------------------

		if (multiSearchOr(GPUInfo.renderer, hqGPUs)) {
			targetFPS = 60;
			renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
			renderer.shadowMap.enabled = true;
			renderer.shadowMap.type = THREE.PCFSoftShadowMap;
			maxAnisotropy = renderer.capabilities.getMaxAnisotropy();
		} else {
			renderer = new THREE.WebGLRenderer({ antialias: false, alpha: true });
			renderer.shadowMap.enabled = false;
			maxAnisotropy = 2;
		}
		renderer.setPixelRatio(window.devicePixelRatio);
		renderer.setSize(window.innerWidth, sceneHeight);
		renderer.setClearColor(colors["white"], 1);
		renderer.gammaInput = true;
		renderer.gammaOutput = true;
		renderer.autoClear = true;
		renderer.powerPreference = "high-performance";
		renderer.domElement.id = "WebGLContainer";

		activeContainer.appendChild(renderer.domElement);


		// Setup mirror Cameras
		// -------------------------

		mirrorSphereCamera = new THREE.CubeCamera(0.1, 300, 512);
		mirrorSphereCamera.renderTarget.texture.minFilter = THREE.LinearMipMapLinearFilter;
		mirrorSphereCamera.position.set(0, 3.5, -1);
		scene.add(mirrorSphereCamera);

		skySphereCamera = new THREE.CubeCamera(0.01, 7, 512);
		skySphereCamera.position.set(-2.3, 7.61, -1);
		skySphereCamera.renderTarget.texture.minFilter = THREE.LinearMipMapLinearFilter;
		skySphereCamera.rotation.z = 180 * Math.PI / 180;
		scene.add(skySphereCamera);

		// TODO maybe we don't need this
		// Performance monitor
		// ------------------------

		if(debug === true) {
			stats = new Stats();
			stats.showPanel( 0 );
			stats.dom.style.left = '26px';
			stats.dom.style.right = 'auto';
			stats.dom.style.top = '60px';
			document.body.appendChild( stats.dom );
		}
		//

		inited = true;
		startAnimating(targetFPS);

		_textureAssembler(tlib, false).then(function (update) {
			window.setTimeout(function () {
				_initAssets();
			}, 100);
		});
	}


	// Assets
	var _initAssets = function () {
		// Room variables
		var roomGeometry, roomTexture, roomMats;

		// Shelf
		var shelfGeometry, shelfTexture, shelfMats;


		// Fill model library
		// -------------------

		TROPHIES = {
			"default_cup": {
				name: "goldPokal",
				rotation: {
					x: 0,
					y: 0,
					z: 0
				},
				position: {
					x: -2.32,
					y: 2.291, //2.391
					z: -1
				},
				scale: 0.01,
				parts: [{
					url: "assets/trophy/models/shared/plate.obj",
					name: "default_cup_plate",
					materialType: "metal",
					material: [],
					enviroment: {
						source: mirrorSphereCamera,
						intensity: 1
					},
					texture: tlib["default_cup_plate"].texture,
					bump: {
						bumpMap: tlib["default_cup_plate"].texture,
						roughnessMap: tlib["default_cup_plate"].texture
					},
					rotation: {
						x: 0,
						y: 0,
						z: 0
					},
					position: {
						x: 0.5,
						y: 0.06,
						z: 0
					},
					scale: -0.002
				}, {
					url: "assets/trophy/models/default_cup/sole.obj",
					name: "sole",
					materialType: "metal",
					material: [],
					enviroment: {
						source: mirrorSphereCamera,
						intensity: 1
					},
					texture: null,
					bump: {
						bumpMap: null,
						roughnessMap: null
					},
					rotation: {
						x: 0,
						y: 0,
						z: 0
					},
					position: {
						x: 0.5,
						y: 0.06,
						z: 0
					},
					scale: -0.002
				}, {
					url: "assets/trophy/models/default_cup/ear_r.obj",
					name: "ear",
					materialType: "metal",
					material: [],
					enviroment: {
						source: mirrorSphereCamera,
						intensity: 1
					},
					texture: null,
					bump: {
						bumpMap: null,
						roughnessMap: null
					},
					rotation: {
						x: 0,
						y: 0,
						z: 0
					},
					position: {
						x: 0.5,
						y: 0.06,
						z: 0
					},
					scale: -0.002
				}, {
					url: "assets/trophy/models/default_cup/ear_l.obj",
					name: "ear",
					materialType: "metal",
					material: [],
					enviroment: {
						source: mirrorSphereCamera,
						intensity: 1
					},
					texture: null,
					bump: {
						bumpMap: null,
						roughnessMap: null
					},
					rotation: {
						x: 0,
						y: 0,
						z: 0
					},
					position: {
						x: 0.5,
						y: 0.06,
						z: 0
					},
					scale: -0.002
				}, {
					url: "assets/trophy/models/default_cup/body_inner.obj",
					name: "default_cup_inner",
					materialType: "metal",
					material: [],
					enviroment: {
						source: skySphereCamera,
						intensity: 1
					},
					/*texture: tlib["default_cup_inner"].texture,
					bump: {
						bumpMap: tlib["default_cup_inner"].texture,
						roughnessMap: null
					},*/
					texture: null,
					bump: {
						bumpMap: null,
						roughnessMap: null
					},
					rotation: {
						x: 0,
						y: 180,
						z: 0
					},
					position: {
						x: 4.11,
						y: 0.06,
						z: 0
					},
					scale: -0.002
				}, {
					url: "assets/trophy/models/default_cup/body_outer.obj",
					name: "default_cup_outer",
					materialType: "metal",
					material: [],
					enviroment: {
						source: mirrorSphereCamera,
						intensity: 1
					},
					texture: tlib["default_cup_outer"].texture,
					bump: {
						bumpMap: tlib["default_cup_outer"].texture,
						roughnessMap: tlib["default_cup_outer"].texture
					},
					rotation: {
						x: 0,
						y: 180,
						z: 0
					},
					position: {
						x: 4.11,
						y: 0.06,
						z: 0
					},
					scale: -0.002
				}, {
					url: "assets/trophy/models/default_cup/stand.obj",
					name: "stand",
					materialType: activeStandMaterial,
					material: [],
					enviroment: {
						source: mirrorSphereCamera,
						intensity: 1
					},
					texture: null,
					bump: {
						bumpMap: null,
						roughnessMap: null
					},
					rotation: {
						x: 0,
						y: 0,
						z: 0
					},
					position: {
						x: 0.5,
						y: 0.06,
						z: 0
					},
					scale: -0.002
				}],
				objects: []
			},

			"global_cup": {
				name: "worldPokal",
				rotation: {
					x: 0,
					y: 0,
					z: 0
				},
				position: {
					x: -1.037,
					y: 2.685, //2.785
					z: -1
				},
				scale: 0.047, //047
				parts: [{
					url: "assets/trophy/models/global_cup/plate.obj",
					name: "global_cup_plate",
					materialType: "metal",
					material: [],
					enviroment: {
						source: mirrorSphereCamera,
						intensity: 1
					},
					texture: tlib["global_cup_plate"].texture,
					bump: {
						bumpMap: tlib["global_cup_plate"].texture,
						roughnessMap: null
					},
					rotation: {
						x: 0,
						y: 0,
						z: 0
					},
					position: {
						x: 0,
						y: 0,
						z: 0
					},
					scale: 0
				}, {
					url: "assets/trophy/models/global_cup/sole.obj",
					name: "sole",
					materialType: "metal",
					material: [],
					enviroment: {
						source: mirrorSphereCamera,
						intensity: 1
					},
					texture: null,
					bump: {
						bumpMap: null,
						roughnessMap: null
					},
					rotation: {
						x: 0,
						y: 0,
						z: 0
					},
					position: {
						x: 0,
						y: 0,
						z: 0
					},
					scale: 0
				}, {
					url: "assets/trophy/models/global_cup/ears.obj",
					name: "ear",
					materialType: "metal",
					material: [],
					enviroment: {
						source: mirrorSphereCamera,
						intensity: 1
					},
					texture: null,
					bump: {
						bumpMap: null,
						roughnessMap: null
					},
					rotation: {
						x: 0,
						y: 0,
						z: 0
					},
					position: {
						x: 0,
						y: 0,
						z: 0
					},
					scale: 0
				}, {
					url: "assets/trophy/models/global_cup/body_inner.obj",
					name: "global_cup_inner",
					materialType: "metal",
					material: [],
					enviroment: {
						source: skySphereCamera,
						intensity: 1
					},
					/*texture: tlib["global_cup_inner"].texture,
					bump: {
						bumpMap: tlib["global_cup_inner"].texture,
						roughnessMap: null
					},*/
					bump: {
						bumpMap: null,
						roughnessMap: null
					},
					rotation: {
						x: 0,
						y: 180,
						z: 0
					},
					position: {
						x: 1.994,
						y: 0,
						z: 0
					},
					scale: 0
				}, {
					url: "assets/trophy/models/global_cup/body_outer.obj",
					name: "global_cup_outer",
					materialType: "metal",
					material: [],
					enviroment: {
						source: mirrorSphereCamera,
						intensity: 1
					},
					texture: tlib["global_cup_outer"].texture,
					bump: {
						bumpMap: tlib["global_cup_outer"].texture,
						roughnessMap: null
					},
					rotation: {
						x: 0,
						y: 180,
						z: 0
					},
					position: {
						x: 1.9954,
						y: 0,
						z: 0
					},
					scale: 0
				}, {
					url: "assets/trophy/models/global_cup/stand.obj",
					name: "stand",
					materialType: activeStandMaterial,
					material: [],
					enviroment: {
						source: mirrorSphereCamera,
						intensity: 1
					},
					texture: null,
					bump: {
						bumpMap: null,
						roughnessMap: null
					},
					rotation: {
						x: 0,
						y: 0,
						z: 0
					},
					position: {
						x: 0,
						y: 0,
						z: 0
					},
					scale: 0
				}],
				objects: []
			},

			"default_medal": {
				name: "goldMedal",
				rotation: {
					x: 0,
					y: 0,
					z: 0
				},
				position: {
					x: -2.32,
					y: 2.291,//2.391
					z: -1
				},
				scale: 0.022,
				parts: [{
					url: "assets/trophy/models/default_medal/medal_inner.obj",
					name: "default_medal_text",
					materialType: "metal",
					material: [],
					enviroment: {
						source: mirrorSphereCamera,
						intensity: 1
					},
					texture: tlib["default_medal_text"].texture,
					bump: {
						bumpMap: tlib["default_medal_text"].texture,
						roughnessMap: null
					},
					rotation: {
						x: 180,
						y: 90,
						z: 75
					},
					position: {
						x: 2.325,
						y: 1.35, //1.19
						z: 0.1
					},
					scale: 0.025,
				}, {
					url: "assets/trophy/models/default_medal/medal_outer.obj",
					name: "medalOuter",
					materialType: "metal",
					material: [],
					enviroment: {
						source: mirrorSphereCamera,
						intensity: 1
					},
					texture: null,
					bump: {
						bumpMap: null,
						roughnessMap: null
					},
					rotation: {
						x: 180,
						y: 90,
						z: 75
					},
					position: {
						x: 2.325,
						y: 1.35,
						z: 0.1
					},
					scale: 0.025,
				}, {
					url: "assets/trophy/models/assets/medal_bracket.obj",
					name: "stand",
					materialType: activeStandMaterial,
					material: [],
					enviroment: {
						source: mirrorSphereCamera,
						intensity: 1
					},
					texture: null,
					bump: {
						bumpMap: null,
						roughnessMap: null
					},
					rotation: {
						x: 0,
						y: 0,
						z: 0
					},
					position: {
						x: 2.325,
						y: 0.33,
						z: -0.5
					},
					scale: 0.022
				}],
				objects: []
			},

			"hannover_medal": {
				name: "Hannover Medal",
				rotation: {
					x: 0,
					y: 0,
					z: 0
				},
				position: {
					x: -2.32,
					y: 2.391,
					z: -1
				},
				scale: 0.01,
				parts: [{
					url: "assets/trophy/models/hannover_medal/medal_base.obj",
					name: "hannover_medal_base",
					materialType: "metal",
					material: [],
					enviroment: {
						source: mirrorSphereCamera,
						intensity: 1
					},
					texture: null,
					bump: {
						bumpMap: null,
						roughnessMap: null
					},
					rotation: {
						x: 180,
						y: 270,
						z: 105
					},
					position: {
						x: 2.275,
						y: 1.09,
						z: -0.16
					},
					scale: 0.025
				}, {
					url: "assets/trophy/models/hannover_medal/medal_top.obj",
					name: "hannover_medal_top",
					materialType: "metal_matte",
					material: [],
					enviroment: {
						source: mirrorSphereCamera,
						intensity: 1
					},
					texture: tlib["hannover_image"].texture,
					bump: {
						bumpMap: null,
						roughnessMap: null
					},
					rotation: {
						x: 180,
						y: 270,
						z: 105
					},
					position: {
						x: 2.275,
						y: 1.09,
						z: -0.16
					},
					scale: 0.025
				}, {
					url: "assets/trophy/models/hannover_medal/medal_bottom.obj",
					name: "hannover_medal_bottom",
					materialType: "metal",
					material: [],
					enviroment: {
						source: mirrorSphereCamera,
						intensity: 1
					},
					texture: tlib["hannover_medal_text"].texture,
					bump: {
						bumpMap: tlib["hannover_medal_text"].texture,
						roughnessMap: null
					},
					rotation: {
						x: 180,
						y: 270,
						z: 105
					},
					position: {
						x: 2.275,
						y: 1.09,
						z: -0.16
					},
					scale: 0.025
				}, {
					url: "assets/trophy/models/hannover_medal/medal_frame.obj",
					name: "medal_frame",
					materialType: "metal",
					material: [],
					enviroment: {
						source: mirrorSphereCamera,
						intensity: 1
					},
					texture: null,
					bump: {
						bumpMap: null,
						roughnessMap: null
					},
					rotation: {
						x: 180,
						y: 270,
						z: 105
					},
					position: {
						x: 2.275,
						y: 1.09,
						z: -0.16
					},
					scale: 0.025
				}, {
					url: "assets/trophy/models/hannover_medal/medal_beam.obj",
					name: "medal_beam",
					materialType: "metal_matte",
					material: [],
					enviroment: {
						source: mirrorSphereCamera,
						intensity: 1
					},
					texture: tlib["hannover_logo"].texture,
					bump: {
						bumpMap: tlib["hannover_logo"].texture,
						roughnessMap: null
					},
					rotation: {
						x: 180,
						y: 270,
						z: 105
					},
					position: {
						x: 2.275,
						y: 1.09,
						z: -0.16
					},
					scale: 0.025
				}, {
					url: "assets/trophy/models/assets/medal_bracket.obj",
					name: "stand",
					materialType: activeStandMaterial,
					material: [],
					enviroment: {
						source: mirrorSphereCamera,
						intensity: 1
					},
					texture: null,
					bump: {
						bumpMap: null,
						roughnessMap: null
					},
					rotation: {
						x: 0,
						y: 0,
						z: 0
					},
					position: {
						x: 2.275,
						y: 0.33,
						z: -0.5
					},
					scale: 0.025
				}],
				objects: []
			},

			"default_cert": {
				name: "certificatePapyrus",
				rotation: {
					x: 0,
					y: 0,
					z: 0
				},
				position: {
					x: -1.32,
					y: 0,
					z: 0
				},
				scale: 0.01,
				parts: [{
					url: "assets/trophy/models/certificate/cert_3.obj",
					name: "default_cert_text",
					materialType: "paper",
					material: [],
					enviroment: {
						source: null,
						intensity: 1
					},
					texture: tlib["default_cert_text"].texture,
					bump: {
						bumpMap: null,
						roughnessMap: null
					},
					rotation: {
						x: 80, // 45,
						y: 0,
						z: 0
					},
					position: {
						x: 1.345,
						y: 2.868,//3.068
						z: -0.465
					},
					scale: 0.06
				}],
				objects: []
			},
			"default_lasvegas":{
				name: "LasVegas",
				rotation: { x: 0, y: 0, z:0 },
				position: { x: -0.25, y: 0.3, z: -1 }, //0.4
				scale: 0.0009,
				parts: [
					{
						url: "assets/trophy/models/lasvegas/lasvegas-medal.obj",
						name: "default_lasvegas_img",
						materialType: "white",
						material: [],
						enviroment: { source: mirrorSphereCamera, intensity:1 },
						texture: tlib["default_lasvegas_img"].texture,
						bump: { bumpMap: tlib["default_lasvegas_img"].texture, roughnessMap: tlib["default_lasvegas_img"].texture },
						rotation: { x: -20, y: 0, z: 0 },
						position: { x: 0.272, y: 2.79, z: 0.28},
						scale:0.0057
					},
					{
						url: "assets/trophy/models/lasvegas/plate2.obj",
						name: "default_plate_text",
						materialType: "metal",
						material: [],
						enviroment: {source: mirrorSphereCamera, intensity: 1.4 },
						texture: tlib["default_plate_text"].texture,
						bump: {
							bumpMap: tlib["default_plate_text"].texture,
							roughnessMap: tlib["default_plate_text"].texture
						},
						rotation: { x: -24, y: 0, z: 0 },
						position: { x: 0.25, y: 2.4, z: 0.349 },
						scale: 0.00075
					},
					{
						url: "assets/trophy/models/lasvegas/lasvegas-outer2.obj",
						name: "stand",
						materialType: activeStandMaterial,
						material: [],
						enviroment: { source: mirrorSphereCamera, intensity: 1 },
						texture: null,
						bump: { bumpMap: null, roughnessMap: null },
						rotation: { x:-3, y: 0, z: 0},
						position: { x: 0.299, y: 2.15, z: -0.52},
						scale: 0.04 ,
					},
					
				],
				objects: [],
			},
			"default_antarctic":{
				name: "Antarctic",
				rotation: { x: 0, y: 0, z:0 },
				position: { x: -0.28, y: 0.55, z: -1 },
				scale: 0.001,
				parts: [
					{
						url: "assets/trophy/models/antarctic-medal/antarctic-medal.obj",
						name: "stand",
						materialType: activeStandMaterial,
						material: [],
						enviroment: { source: mirrorSphereCamera, intensity: 1 },
						texture: null,
						bump: { bumpMap: null, roughnessMap: null },
						rotation: { x: 0, y: 0, z: 0 },
						position: { x: 0.32, y: 2.1, z: -0.5},
						scale: 0.039,
					},
					{
						url: "assets/trophy/models/antarctic-medal/medal_inner.obj",
						name: "default_antarctic_img",
						materialType: "white",
						material: [],
						enviroment: { source: mirrorSphereCamera, intensity: 1 },
						texture: tlib["default_antarctic_img"].texture,
						bump: { bumpMap: tlib["default_antarctic_img"].texture, roughnessMap: tlib["default_antarctic_img"].texture },
						rotation: { x: 165, y: 90, z: 90},
						position: { x: 0.31, y: 3.09, z: 0.13 },
						scale: 0.074,
					   
					},
					{
						url: "assets/trophy/models/antarctic-medal/plate.obj",
						name: "default_plate_text_a",
						materialType: "metal",
						material: [],
						enviroment: {source: mirrorSphereCamera, intensity: 1.4 },
						texture: tlib["default_plate_text_a"].texture,
						bump: {
							bumpMap: tlib["default_plate_text_a"].texture,
							roughnessMap: tlib["default_plate_text_a"].texture
						},
						rotation: { x: -16, y: 0, z: 0 },
						position: { x: 0.31, y: 2.15, z: 0.419},
						scale: 0.00045
					},
				],
				objects: [],
			},
			"default_paris":{
				name: "Paris",
				rotation: { x: 0, y: 0, z:0 },
				position: { x: -0.64, y: -0.1, z: -1 }, //0
				scale: 0.00057,
				parts: [
					{
						url: "assets/trophy/models/paris/paris-outer.obj",
						name: "stand",
						materialType: activeStandMaterial,
						material: [],
						enviroment: { source: mirrorSphereCamera, intensity: 1 },
						texture: null,
						bump: { bumpMap: null, roughnessMap: null },
						rotation: { x:0, y: 0, z: 0 },
						position: { x: 0.7, y: 2.63, z: -0.5},
						scale: 0.03 ,
					},
					{
						url: "assets/trophy/models/paris/paris-medal.obj",
						name: "default_paris_img",
						materialType: "white",
						material: [],
						enviroment: { source: mirrorSphereCamera, intensity: 1 },
						texture: tlib['default_paris_img'].texture,
						bump: { bumpMap: tlib["default_paris_img"].texture, roughnessMap: null },
						rotation: { x: -12, y:5, z: 0 },
						position: { x: 0.68, y: 3.23, z: 0.23},
						scale: 0.0022,
					},
					{
						url: "assets/trophy/models/paris/plate.obj",
						name: "default_plate_text_p",
						materialType: "metal",
						material: [],
						enviroment: {source: mirrorSphereCamera, intensity: 1.4 },
						texture: tlib["default_plate_text_p"].texture,
						bump: {
							bumpMap: tlib["default_plate_text_p"].texture,
							roughnessMap: tlib["default_plate_text_p"].texture
						},
						rotation: { x: -10.5, y: -1, z: 0 },
						position: { x: 0.65, y: 2.85, z: 0.182 },
						scale: 0.0007
					},
				],
				objects: [],
			},
			"default_greatwall":{
				name: "Greatwall",
				rotation: { x: 0, y: 0, z:0 },
				position: { x: -0.72, y: 1.45, z:-1 },
				scale: 0.00018,
				parts: [
					{
						url: "assets/trophy/models/great-wall/great-wall.obj",
						name: "default_greatwall_img",
						materialType: "white",
						material: [],
						enviroment: { source: mirrorSphereCamera, intensity: 1 },
						texture: tlib['default_greatwall_img'].texture,
						bump: { bumpMap: tlib["default_greatwall_img"].texture, roughnessMap: tlib["default_greatwall_img"].texture, },
						rotation: { x: -22, y: 0, z: 0 },
						position: { x: 0.74, y: 1.83, z: 0.1},
						scale: 0.00322,
					},
					{
						url: "assets/trophy/models/great-wall/greatwall-outer2.obj",
						name: "stand",
						materialType: activeStandMaterial,
						material: [],
						enviroment: { source: mirrorSphereCamera, intensity: 1 },
						texture: null,
						bump: { bumpMap: null, roughnessMap: null },
						rotation: { x:0, y: 0, z: 0 },
						position: { x: 0.77, y: 1.18, z: -0.5},
						scale: 0.035 ,
					},
					{
						url: "assets/trophy/models/great-wall/plate.obj",
						name: "default_plate_text_g",
						materialType: "metal",
						material: [],
						enviroment: {source: mirrorSphereCamera, intensity: 1.4 },
						texture: tlib["default_plate_text_g"].texture,
						bump: {
							bumpMap: tlib["default_plate_text_g"].texture,
							roughnessMap: tlib["default_plate_text_g"].texture
						},
						rotation: { x: -15, y: 0, z: 0 },
						position: { x: 0.77, y: 1.32, z: 0.285 },
						scale: 0.0015
					},
				],
				objects: [],
			},
			"default_losangeles":{
				name: "LosAngeles",
				rotation: { x: 0, y: 0, z:0 },
				position: { x: -0.45, y: 0.07, z: -1 },
				scale: 0.00034,
				parts: [
					{
						url: "assets/trophy/models/los-angeles/medal_bracket1.obj",
						name: "stand",
						materialType: activeStandMaterial,
						material: [],
						enviroment: { source: mirrorSphereCamera, intensity: 1 },
						texture: null,
						bump: { bumpMap: null, roughnessMap:  null },
						rotation: { x: 0, y: 0, z: 0 },
						position: { x: 0.49, y: 2.6, z: -0.5},
						scale: 0.037, 
					},
					{
						url: "assets/trophy/models/los-angeles/medal_inner.obj",
						name: "default_losangeles_img",
						materialType: "white",
						material: [],
						enviroment: { source: mirrorSphereCamera, intensity: 1 },
						texture: tlib['default_losangeles_img'].texture,
						bump: { bumpMap: tlib["default_losangeles_img"].texture, roughnessMap: tlib["default_losangeles_img"].texture },
						rotation: { x: -195, y: 85, z: 90 },
						position: { x: 0.5, y: 3.455, z: 0.1 }, 
						scale: 0.047,
					},
					{
						url: "assets/trophy/models/los-angeles/medal-outer-notext.obj",
						name: "default_losangeles",
						materialType: "metal_silver_custom",
						material: [],
						enviroment: { source: mirrorSphereCamera, intensity: 0.6 },
						texture: null,
						bump: { bumpMap: null, 
						roughnessMap: null },
						rotation: { x: 0, y: 0, z: 0 },
						position: { x: 0.49, y: 2.4, z: -0.8 },
						scale: 0.041,
					},
					{
						url: "assets/trophy/models/los-angeles/medal-outer.obj",
						name: "default_losangeles",
						materialType: "black",
						material: [],
						enviroment: { source: mirrorSphereCamera, intensity: 1 },
						texture: null,
						bump: { bumpMap: null, 
						roughnessMap: null },
						rotation: { x: 0, y: 0, z: 0 },
						position: { x: 0.49, y: 2.4, z: -0.79 },
						scale: 0.04,
					},
					{
						url: "assets/trophy/models/antarctic-medal/plate.obj",
						name: "default_plate_text_la",
						materialType: "metal",
						material: [],
						enviroment: {source: mirrorSphereCamera, intensity: 1.4 },
						texture: tlib["default_plate_text_la"].texture,
						bump: {
							bumpMap: tlib["default_plate_text_la"].texture,
							roughnessMap: tlib["default_plate_text_la"].texture
						},
						rotation: { x: -15, y: 0, z: 0 },
						position: { x: 0.46, y: 2.66, z: 0.343},
						scale: 0.0009
					},
				],
				objects: [],
			},
			"default_newyork":{
				name: "NewYork",
				rotation: { x: 0, y: 0, z:0 },
				position: { x: -0.70, y: -0.1, z: -1 }, //0
				scale: 0.00023,
				parts: [
					{
						url: "assets/trophy/models/new-york/New-york.obj",
						name: "default_newyork_img",
						materialType: "white",
						material: [],
						enviroment: { source: mirrorSphereCamera, intensity: 1 },
						texture: tlib['default_newyork_img'].texture,
						bump: { bumpMap: tlib["default_newyork_img"].texture, roughnessMap: tlib["default_newyork_img"].texture, },
						rotation: { x: -17, y: 0, z: 1 },
						position: { x: 0.39, y: 3.2, z: -0.2},
						scale: 0.0097,
					},
					{
						url: "assets/trophy/models/new-york/newyork-outer2.obj",
						name: "stand",
						materialType: activeStandMaterial,
						material: [],
						enviroment: { source: mirrorSphereCamera, intensity: 1 },
						texture: null,
						bump: { bumpMap: null, roughnessMap: null },
						rotation: { x:0, y: 0, z: 0 },
						position: { x: 0.77, y: 2.7, z: -0.5},
						scale: 0.033 ,
					},
					{
						url: "assets/trophy/models/new-york/plate.obj",
						name: "default_plate_text_ny",
						materialType: "metal",
						material: [],
						enviroment: {source: mirrorSphereCamera, intensity: 1.4 },
						texture: tlib["default_plate_text_ny"].texture,
						bump: {
							bumpMap: tlib["default_plate_text_ny"].texture,
							roughnessMap: tlib["default_plate_text_ny"].texture
						},
						rotation: { x: -15.5, y: 0.5, z: 0 },
						position: { x: 0.75, y: 2.82, z: 0.245},
						scale: 0.0015
					},
				],
				objects: [],
			}
		}

		// Translate property IDs to array keys
		_changeModels(defaultModel, false);

		LObjects = activeTrophy.a.parts.length;

		
		// Controlls
		// -------------------------

		controls = new THREE.OrbitControls( camera, renderer.domElement );
		// controls.target = new THREE.Vector3(0, 4.2, -1); 4.05
		controls.target = new THREE.Vector3(0, 3.5, -1);//3.85

		controls.enableDamping = true;
		controls.dampingFactor = 1;
		controls.enableZoom = true;
		controls.autoRotate = false;
		controls.enableKeys = true;
		controls.rotateSpeed = 0.35;
		if(debug === false) {
			controls.minPolarAngle = Math.PI/6;
			controls.maxPolarAngle = Math.PI/2;
			controls.minAzimuthAngle = - Math.PI/3;
			controls.maxAzimuthAngle = Math.PI/3;
			controls.minDistance = 2.3; //1.5
			controls.maxDistance = 7;//10
			controls.enablePan = false;
		} else {
			controls.enablePan = true;
			controls.screenSpacePanning = true;
		}
		//

		// Ambient Lights
		// -------------------------

		ambient = new THREE.AmbientLight(colors["white"], 0.7);
		scene.add(ambient);


		// Lights
		// -------------------------

		lights[ 0 ] = new THREE.DirectionalLight( colors["white"], 0.3 );
		lights[ 1 ] = new THREE.DirectionalLight( colors["white"], 0.3 );

		lights[ 0 ].position.set( 3, 7, 3);
		lights[ 1 ].position.set( -3, 7, 3);

		lights[ 0 ].target.position.set( 0, 3, -0.5);
		lights[ 1 ].target.position.set( 0, 3, -0.5);

		lights[ 0 ].angle = Math.PI / 10;
		lights[ 1 ].angle = Math.PI / 10;

		setAll(lights, "penumbra", "0.05");
		setAll(lights, "decay", "1");
		setAll(lights, "distance", "200");
		setAll(lights, "castShadow", true);

		setAll(lights, "shadow.mapSize.width", 512);
		setAll(lights, "shadow.mapSize.height", 512);
		setAll(lights, "shadow.camera.near", 0.5);
		setAll(lights, "shadow.camera.far", 500);

		setAll(lights, "power", 3500);

		scene.add( lights[ 0 ], lights[ 0 ].target );
		scene.add( lights[ 1 ], lights[ 1 ].target );


		if(debug === true) {
			for(var i = 0; i < 2; i++) {
				var helper = new THREE.CameraHelper( lights[ i ].shadow.camera );
				scene.add( helper );
			}
		}


		// Setup room
		// -------------------------

		roomGeometry = new THREE.BoxBufferGeometry( 20, 14, 20 );
		roomMats = [
			new THREE.MeshPhongMaterial({
				// Right
				color: colors["white"],
				side: THREE.BackSide
			}), 
			new THREE.MeshPhongMaterial({
				// Left
				color: colors["white"],
				side: THREE.BackSide
			}), 
			new THREE.MeshPhongMaterial({
				// Top
				color: colors["white"],
				side: THREE.BackSide
			}), 
			new THREE.MeshStandardMaterial({
				// Bottom
				color: colors["white"],
				side: THREE.BackSide
				// roughness: 1,
				// color: colors["white"],
				// metalness: 0,
				// bumpScale: 0.0005,
				// map: tlib["shelf_texture"].texture,
				// bumpMap: tlib["shelf_texture"].texture,
				// roughnessMap: tlib["shelf_texture"].texture,
				// side: THREE.BackSide
			}), 
			new THREE.MeshPhongMaterial({
				// Back
				color: colors["white"],
				side: THREE.BackSide
			}), 
			new THREE.MeshPhongMaterial({
				// Front
				color: colors["white"],
				side: THREE.BackSide
			})
		];

		roomMesh = new THREE.Mesh( roomGeometry, roomMats );
		roomMesh.position.y = 6;
		roomMesh.position.z = 6;
		roomMesh.receiveShadow = true;

		scene.add( roomMesh );

		// Setup shelf
		// -------------------------

		shelfGeometry = new THREE.BoxBufferGeometry(15, 0.1, 1.5);
		// shelfGeometry = new THREE.BoxBufferGeometry(35, 0.1, 1.5);
		shelfTexture = tlib["shelf_texture"].texture;
		shelfTexture.wrapS = shelfTexture.wrapT = THREE.RepeatWrapping;
		shelfTexture.repeat.set(1, 1);

		shelfMats = new THREE.MeshStandardMaterial({
			roughness: 1,
			color: colors["white"],
			metalness: 0,
			bumpScale: 0.0005,
			map: shelfTexture,
		});

		shelfMesh = new THREE.Mesh(shelfGeometry, shelfMats);
		shelfMesh.position.y = 2.6; //2.6
		shelfMesh.position.z = -1; //-1
		// shelfMesh.receiveShadow = true;
		shelfMesh.receiveShadow = false;

		scene.add(shelfMesh);


		// Listeners
		// -------------------------

		// Resize
		window.addEventListener('resize', _onWindowResize, false);


		// Models
		// -------------------------

		return _modelLoader(activeTrophy.a);
	}


	//
	// Texture operations
	// -------------------------

	var _textureAssembler = function (lib, update, keys) {
		// lib: Texture library
		// keys: Specific key for which texture needs updating
		return new Promise(function (resolve, reject) {
			var i, length;

			if (update === true) {
				if (keys && typeof keys == "string") {
					if (lib[keys].raw !== null) {
						lib[keys].raw(update, lib, keys).then(function (texture) {
							// DEBUG
							// console.log(keys + " updated");
							if (lib[keys]) {
								lib[keys].texture.image = texture;
								lib[keys].texture.needsUpdate = true;
							}

							// Render changes
							setTimeout(function () {
								render();
							}, 100);
						});
					}
				} else {
					Object.keys(lib).forEach(function (key) {
						if (lib[key].raw !== null) {
							lib[key].raw(update, lib, key).then(function (texture) {
								// DEBUG
								// console.log(key + " updated");
								lib[key].texture.image = texture;
								lib[key].texture.needsUpdate = true;

								// Render changes
								setTimeout(function () {
									render();
								}, 100);
							});
						}
					});
				}
			} else {
				Object.keys(lib).forEach(function (key) {
					if (lib[key].raw !== null) {
						lib[key].raw(update, lib, key).then(function (texture) {
							// DEBUG
							// console.log(key + " assembled");
							lib[key].texture = new THREE.Texture(texture);
							if (!isEmpty(lib[key].texture)) {
								switch (lib[key].properties.wrap) {
									case "edge":
										lib[key].texture.wrapS = lib[key].texture.wrapT = THREE.ClampToEdgeWrapping;
										break;
									case "repeat":
										lib[key].texture.wrapS = lib[key].texture.wrapT = THREE.RepeatWrapping;
										break;
									default:
										return;
								}

								lib[key].texture.anisotropy = maxAnisotropy;
								lib[key].texture.rotation = lib[key].properties.rotation;
								lib[key].texture.repeat.x = lib[key].properties.repeat.x;
								lib[key].texture.repeat.y = lib[key].properties.repeat.y;
								lib[key].texture.offset.x = lib[key].properties.offset.x;
								lib[key].texture.offset.y = lib[key].properties.offset.y;
								lib[key].texture.needsUpdate = true;
							}

							// Render changes
							setTimeout(function () {
								render();
							}, 100);
						});
					} else {
						if (!isEmpty(lib[key].texture)) {
							switch (lib[key].properties.wrap) {
								case "edge":
									lib[key].texture.wrapS = lib[key].texture.wrapT = THREE.ClampToEdgeWrapping;
									break;
								case "repeat":
									lib[key].texture.wrapS = lib[key].texture.wrapT = THREE.RepeatWrapping;
									break;
								default:
									return;
							}

							lib[key].texture.anisotropy = maxAnisotropy;
							lib[key].texture.rotation = lib[key].properties.rotation;
							lib[key].texture.repeat.x = lib[key].properties.repeat.x;
							lib[key].texture.repeat.y = lib[key].properties.repeat.y;
							lib[key].texture.offset.x = lib[key].properties.offset.x;
							lib[key].texture.offset.y = lib[key].properties.offset.y;
							lib[key].texture.needsUpdate = true;
						}

						// Render changes
						setTimeout(function () {
							render();
						}, 100);
					}
				});
			}

			// Resolve the result
			resolve(update);
		});
	}


	//
	// Model building
	// -------------------------

	// Model loading
	var _modelLoader = function (model, update) {
		// model: definition of a model

		var i, length;
		var parts = model.parts;

		if (update === true && model.objects.length > 0) {
			length = model.objects.length;

			for (i = 0; i < length; i++) {
				scene.add(model.objects[i]);
				model.objects[i].visible = true;
			}

			activeTrophy.a = model;
		} else {
			length = parts.length;

			for (i = 0; i < length; i++) {
				OBJLoader.load(
					parts[i].url,
					_modelAssembler(model, parts[i], update, {
						rotationX: model.rotation.x + parts[i].rotation.x,
						rotationY: model.rotation.y + parts[i].rotation.y,
						rotationZ: model.rotation.z + parts[i].rotation.z,
						positionX: model.position.x + parts[i].position.x,
						positionY: model.position.y + parts[i].position.y,
						positionZ: model.position.z + parts[i].position.z,
						scale: model.scale + parts[i].scale
					})
				);
			}
		}
	}


	// Model assembling
	var _modelAssembler = function (model, part, update, options) {
		// model: definition of a model
		// part: definition of a part of the model
		// options: custom options

		options.rotationX = options.rotationX || false;
		options.rotationY = options.rotationY || false;
		options.rotationZ = options.rotationZ || false;

		options.positionX = options.positionX || 0;
		options.positionY = options.positionY || 0;
		options.positionZ = options.positionZ || 0;

		options.scale = options.scale || 0.01;

		return function (object) {
			// object: calculated, render-ready object

			// Positions
			object.scale.set(options.scale, options.scale, options.scale);

			object.position.x = options.positionX;
			object.position.y = options.positionY;
			object.position.z = options.positionZ;

			if (options.rotationX != false) {
				object.rotation.x = options.rotationX * Math.PI / 180;
			}

			if (options.rotationY != false) {
				object.rotation.y = options.rotationY * Math.PI / 180;
			}

			if (options.rotationZ != false) {
				object.rotation.z = options.rotationZ * Math.PI / 180;
			}

			// Update
			object.matrixAutoUpdate = false;
			object.updateMatrix();

			if (part.name) {
				object.name = part.name;
			}

			if (part.materialType) {
				object.materialType = part.materialType;
			}

			// Paint
			_fitMaterial(part, object, model, update);
		}
	}


	// Model painting
	var _fitMaterial = function (part, object, model, update) {
		// part: definition of a part of the model
		// object: calculated, render-ready object
		var material;
		var materialType = part.materialType;

		if (materialType && materialType != null) {
			switch (mlib[materialType].type) {
				case "standard":
					material = new THREE.MeshStandardMaterial(mlib[materialType].properies);
					break;
				case "basic":
					material = new THREE.MeshBasicMaterial(mlib[materialType].properies);
					break;
				default:
					return;
			}

			// If enviroment map defined
			if (part.enviroment.source) {
				material.envMap = part.enviroment.source.renderTarget.texture;
				material.envMapIntensity = part.enviroment.intensity;
			}

			// If texture defined
			if (part.texture) {
				material.map = part.texture;
			}

			// If bumpMap defined
			if (part.bump["bumpMap"]) {
				material.bumpMap = part.bump["bumpMap"]
			}

			// If roughnessMap defined
			if (part.bump["roughnessMap"]) {
				material.roughnessMap = part.bump["roughnessMap"]
			}

		} else {
			material = new THREE.MeshBasicMaterial({ color: colors["white"], wireframe: true })
		}

		material.needsUpdate = true;
		//part.material = material;

		// Traverse for children
		object.traverse(function (child) {
			if (child.material) {
				// child.material.dispose();
				delete child.material;
			}
			child.material = material;
			child.receiveShadow = true;
			child.castShadow = true;
		});

		// Merge
		if (model) {
			if (update === true) {
				model.objects.push(object);
			} else {
				_addModelToScene(model, object);
			}
		}
	}


	//
	// Scene operations
	// ------------------------------

	// Add model
	var _addModelToScene = function (model, object) {
		// model: definition of a model
		// object: calculated, render-ready object

		scene.add(object);
		model.objects.push(object);

		loadingState += (1 / LObjects) / 2;
		// progressbar.animate(loadingState);
	}

	// Show model
	var _showModel = function (model) {
		// model: definition of a model

		var i, length;

		length = model.objects.length;

		for (i = 0; i < length; i++) {
			scene.add(model.objects[i]);
			model.objects[i].visible = true;
		}
	}

	// Change model
	var _changeModelOnSchene = function (model) {
		// model: definition of a model

		var i, length;
		var activeParts = activeTrophy.a.objects;

		length = activeParts.length;
		for (i = 0; i < length; i++) {
			activeParts[i].visible = false;
			scene.remove(activeParts[i]);
		}

		activeTrophy.a = model;
		_modelLoader(model, true);
	}


	//
	// Updates
	// --------------------------------

	// Color
	var _updateColor = function (part, color) {
		// part: which materialType should be updated
		// color: library name of new color

		var i, length;

		// Change color in material library
		mlib["metal"].properies.color = color;

		// Change properties in library
		Object.keys(TROPHIES).forEach(function (key) {
			length = TROPHIES[key].parts.length;
			for (i = 0; i < length; i++) {
				// definitions
				if (!isEmpty(TROPHIES[key].objects[i]) && TROPHIES[key].objects[i].materialType == part) {
					TROPHIES[key].objects[i].traverse(function (child) {
						if (child instanceof THREE.Mesh) {
							child.material.color.setHex(color);
							child.material.needsUpdate = true;
						}
					});
				}
			}
		});
	}


	// Material
	var _updateMaterial = function (part, newMaterial) {
		// part: which materialType should be updated
		// newMaterial: Library name of new material

		var i, o, plength, olength, surfaceParams;

		// Change properties in library
		Object.keys(TROPHIES).forEach(function (key) {
			// definitions
			plength = TROPHIES[key].parts.length;
			for (i = 0; i < plength; i++) {
				if (typeof TROPHIES[key].parts[i].name !== 'undefined' && TROPHIES[key].parts[i].name == part) {
					TROPHIES[key].parts[i].materialType = newMaterial;
					surfaceParams = TROPHIES[key].parts[i];
				}
			}
			// prepared objects
			olength = TROPHIES[key].objects.length;
			for (o = 0; o < olength; o++) {
				if (!isEmpty(TROPHIES[key].objects[o]) && TROPHIES[key].objects[o].name == part) {
					_fitMaterial(surfaceParams, TROPHIES[key].objects[o]);
				}
			}
		});
	}


	// Reflection
	var _updateReflection = function () {
		if (!reflectionUpdate) {
			reflectionUpdate = true;
			// Temporary hide the reflecting object, to clear out the render garbages
			// GL_INVALID_OPERATION : glDrawArrays: Source and destination textures of the draw are the same.
			for (var i = 0; i < activeTrophy.a.objects.length; i++) {
				activeTrophy.a.objects[i].visible = false;
			}

			mirrorSphereCamera.update(renderer, scene);
			skySphereCamera.update(renderer, scene);

			for (var i = 0; i < activeTrophy.a.objects.length; i++) {

				activeTrophy.a.objects[i].visible = true;
			}
			reflectionUpdate = false;
		}
	}


	// Camera position in showTrophy moveCamera()
	var _updateCameraPosition = function (p) {
		var x = p.x;
		var y = p.y;
		var z = p.z;
		if (typeof camera != 'undefined') {
			console.log("%cUpdating camera position " + x + ", " + y + ", " + z, 'color: #2196f3');

			camera.position.set(x, y, z);
		}
	}


	// Textures
	var _updateTextures = function (key) {
		// DEBUG
		// console.log("Updating textures");
		_textureAssembler(tlib, true, key).then(function (update) {
			// DEBUG
			// console.log("Textures updated successfull");

			setTimeout(function () {
				render();
			}, 100);
		});
	}


	//
	// Translators
	// ------------------------------

	// Model
	var _changeModels = function (id, update) {
		if(id==='Pokal Gold') {id = 'goldPokal';};
		if(id==='Pokal World') id = 'worldPokal';
		if(id==='Goldmedaille') id = 'goldMedal';
		if(id==='Urkunde Papyrus') id = 'certificatePapyrus';
		if(id==='Las Vegas') id = 'LasVegas';
		if(id==='New York') id = 'NewYork';
		if(id==='Los Angeles') id = 'LosAngeles';
		console.log(id)
		if (blockedLoading === false) {
			var ntp;
			var ntpName;
			var ntpID;

			if (isNumber(id)) {
				switch (id) {
					case 0:
						ntp = TROPHIES["default_cup"];
						ntpName = "default_cup";
						ntpID = 0;
						break;
					case 1:
						ntp = TROPHIES["default_cup"];
						ntpName = "default_cup";
						ntpID = 1;
						break;
					case 2:
						ntp = TROPHIES["default_cup"];
						ntpName = "default_cup";
						ntpID = 2;
						break;
					case 3:
						ntp = TROPHIES["global_cup"];
						ntpName = "global_cup";
						ntpID = 3;
						break;
					case 4:
						ntp = TROPHIES["default_medal"];
						ntpName = "default_medal";
						ntpID = 4;
						break;
					case 5:
						ntp = TROPHIES["default_medal"];
						ntpName = "default_medal";
						ntpID = 5;
						break;
					case 6:
						ntp = TROPHIES["default_medal"];
						ntpName = "default_medal";
						ntpID = 6;
						break;
					case 7:
						ntp = TROPHIES["default_cert"];
						ntpName = "default_cert";
						ntpID = 7;
						break;
					case 8:
						ntp = TROPHIES["hannover_medal"];
						ntpName = "hannover_medal";
						ntpID = 8;
						break;
					case 9:
						ntp = TROPHIES["default_lasvegas"];
						ntpName = "default_lasvegas";
						ntpID = 9;
						break;
					case 10:
						ntp = TROPHIES["default_paris"];
						ntpName = "default_paris";
						ntpID = 10;
						break;
					case 11:
						ntp = TROPHIES["default_antarctic"];
						ntpName = "default_antarctic";
						ntpID = 11;
					break;
					case 12:
						ntp = TROPHIES["default_greatwall"];
						ntpName = "default_greatwall";
						ntpID = 12;
					break;
					case 13:
						ntp = TROPHIES["default_losangeles"];
						ntpName = "default_losangeles";
						ntpID = 13;
						break;
						case 14:
						ntp = TROPHIES["default_newyork"];
						ntpName = "default_newyork";
						ntpID = 14;
						break;
					default:
						ntp = TROPHIES["default_cup"];
						ntpName = "default_cup";
						ntpID = 0;
				}
			} else {
				switch (id) {
					case "goldPokal":
						ntp = TROPHIES["default_cup"];
						ntpName = "default_cup";
						ntpID = 0;
						break;
					case "PokalSilber":
						ntp = TROPHIES["default_cup"];
						ntpName = "default_cup";
						ntpID = 1;
						break;
					case "PokalBronze":
						ntp = TROPHIES["default_cup"];
						ntpName = "default_cup";
						ntpID = 2;
						break;
					case "worldPokal":
						ntp = TROPHIES["global_cup"];
						ntpName = "global_cup";
						ntpID = 3;
						break;
					case "goldMedal":
						ntp = TROPHIES["default_medal"];
						ntpName = "default_medal";
						ntpID = 4;
						break;
					case "Silberdmedaille":
						ntp = TROPHIES["default_medal"];
						ntpName = "default_medal";
						ntpID = 5;
						break;
					case "Bronzemedaille":
						ntp = TROPHIES["default_medal"];
						ntpName = "default_medal";
						ntpID = 6;
						break;
					case "certificatePapyrus":
						ntp = TROPHIES["default_cert"];
						ntpName = "default_cert";
						ntpID = 7;
						break;
					case "Hannover Medal":
						ntp = TROPHIES["hannover_medal"];
						ntpName = "hannover_medal";
						ntpID = 8;
						break;
					case "LasVegas":
						ntp = TROPHIES["default_lasvegas"];
						ntpName = "default_lasvegas";
						ntpID = 9;
						break;
					case "Paris":
						ntp = TROPHIES["default_paris"];
						ntpName = "default_paris";
						ntpID = 10;
					break;
					case "Antarctic":
						ntp = TROPHIES["default_antarctic"];
						ntpName = "default_antarctic";
						ntpID = 11;
					break;
						case "Greatwall":
						ntp = TROPHIES["default_greatwall"];
						ntpName = "default_greatwall";
						ntpID = 12;
						break;
					case "LosAngeles":
						ntp = TROPHIES["default_losangeles"];
						ntpName = "default_losangeles";
						ntpID = 13;
					break;
					case "NewYork":
						ntp = TROPHIES["default_newyork"];
						ntpName = "default_newyork";
						ntpID = 14;
					break;
					default:
						ntp = TROPHIES["default_cup"];
						ntpName = "default_cup";
						ntpID = 0;
				}
			}

			// Same change request
			if (modelsReady === true && currentModelId == ntpID) {
				return false;
			}

			if (update) {
				_changeModelOnSchene(ntp);
			}

			_changeZoom(ntpID);
			console.log(ntpID)

			activeTrophy = { a: ntp };
			currentModelId = ntpID;
			currentModelName = ntpName;
		}
	}


	// Color
	var _changeModelColor = function (id, update) {
		switch (id) {
			case 0:
				activeModelColor = "gold";
				break;
			case 1:
				activeModelColor = "silver";
				break;
			case 2:
				activeModelColor = "bronze";
				break;
			default:
				activeModelColor = "gold";
		}

		if (update) {
			_updateColor("metal", colors[activeModelColor]);
			activeModelColorId = id;
		}
	}


	// Stand type
	var _changeStand = function (id, update) {
		switch (id) {
			case 0:
				activeStandMaterial = "redwood";
				break;
			case 1:
				activeStandMaterial = "white_marble";
				break;
			case 2:
				activeStandMaterial = "dark_marble";
				break;
			case 3:
				activeStandMaterial = "shiny_black";
				break;
			case 4:
				activeStandMaterial = "blue_glass";
				break;
			default:
				activeStandMaterial = "redwood";
		}

		if (update) {
			_updateMaterial("stand", activeStandMaterial);
			activeStandMaterialId = id;
		}
	}


	// Zoom
	var _changeZoom = function (modelId) {
		var position = {
			x: 0,
			y: 3.8, //4.0
			z: 3.7
		};

		switch (modelId) {
			case 0:
				// Default Cup
				position.y = 3.85;
				position.z = 4.7;
				break;
			case 1:
				position.y = 3.85;
				position.z = 4.7;
				break;
			case 2:
				position.y = 3.85;
				position.z = 4.7;
				break;
			case 3:
				// Global cup
				position.x = -0.05;
				position.y = 4.2;
				position.z = 5.2;
				break;
			case 4:
				// Default medal
				position.x = -0.05;
				position.y = 1.8;
				position.z = 2.7;
				break;
			case 5:
				position.x = -0.05;
				position.y = 1.8;
				position.z = 2.7;
				break;
			case 6:
				position.x = -0.05;
				position.y = 1.8;
				position.z = 2.7;
				break;
			case 7:
				// Default Cert
				position.x = -0.05;
				position.z = 3.2;
				break;
			case 8:
				// Hannover medal
				position.x = -0.05;
				position.y = 3.4;
				position.z = 1.8;
				break;
			case 9:
				position.x = 0.1;
				position.y = 1.5; 
				position.z = 1.9;
				break;
			case 10:
				position.x = -0.1;
				position.y = 2.2;
				position.z = 1.7;
				break;
			case 11:
				position.x = -0.3;
				position.y = 1.5;
				position.z = 1.7;
				break;
			case 12:
				position.x = -0.1;
				position.y = 1.8;
				position.z = 1.7;
				break;
			case 13:
				position.x = 0.1;
				position.y = 2.1; 
				position.z = 1.7;
				break;
			case 14:
				position.x = -0.1;
				position.y = 2;
				position.z = 1.7;
				break;
			default:
				console.error("Not valid model ID.");
				return false;
		}
		return _updateCameraPosition(position);
	}


	/**
	 * --------------------------------------------------------------------------
	 * Public Api
	 * --------------------------------------------------------------------------
	 */


	// Rendering
	// --------------------------------

	function render() {
		// DEBUG
		// console.log("Render");
		renderer.render(scene, camera);
	}


	// Swap model
	// --------------------------------

	function swapModel(params) {
		if(params.trophyType==='Pokal Gold' || params.trophyType==='goldPokal') {params.trophyType = 'goldPokal';};
		if(params.trophyType==='Pokal World') params.trophyType = 'worldPokal';
		if(params.trophyType==='Goldmedaille') params.trophyType = 'goldMedal';
		if(params.trophyType==='Urkunde Papyrus') params.trophyType = 'certificatePapyrus';
		if(params.trophyType==='Las Vegas') params.trophyType = 'LasVegas';
		if(params.trophyType==='New York') params.trophyType = 'NewYork';
		if(params.trophyType==='Los Angeles') params.trophyType = 'LosAngeles';
		if(params.trophyType==='undefined') params.trophyType = 'goldPokal';
		if(params.trophyType==='') params.trophyType = 'goldPokal';
		console.log( params.trophyType)

		console.log("%cSTROPHY SWAP", 'color: #2196f3');
		if(params.trophyType==='goldPokal' ||params.trophyType==='Pokal Gold' ){
			sceneHeight = window.innerHeight +70
			if(params.offset<80) sceneHeight = window.innerHeight -40
		}
		else if(params.trophyType === 'worldPokal'){
			sceneHeight = window.innerHeight + parseInt(params.offset) 
		}else{
			params.offset = 147
			sceneHeight = window.innerHeight - parseInt(params.offset) 
			if(params.offset<80 && params.trophyType==='NewYork' || params.offset<80 && params.trophyType==='New York'){
				sceneHeight=window.innerHeight -250
			}
		}
		var properties = params;

		activeLoader = setTimeout(function () {
			document.querySelectorAll('.trophy-loader').forEach(function (item) {
				show(item);
			})
		}, 100);
		resizeRenderer(sceneHeight);
		_changeModels(params.trophyType, true);
		_changeModelColor(parseInt(params.trophyColor) - 1, true);
		_changeStand(parseInt(params.trophyMaterial) - 1, true)

		// Active Texts
		txtDisplayName = params.athleteName;
		txtDisplayEvtName = params.eventName;
		txtDisplayStrecke = params.hasStrecke === true ? params.distance : "";
		txtDisplayZeit = params.hasZeit === true ? params.time : "";
		txtDisplayDatum = params.hasDatum === true ? params.formatedDate : "";

		if (typeof params.platz !== 'undefined' && params.hasPlatz === true && params.time !== 'undefined') {
			txtDisplayPlatz = params.platz + ". Platz";
		} else {
			txtDisplayPlatz = ""
		}

		// if (params.trophyType.toUpperCase().includes("MEDAL")) {
		// 	txtDisplayPlatz += " in " + params.time;
		// }

		Object.keys(tlib).forEach(function (key) {
			if (tlib[key].model !== null && tlib[key].model === currentModelName) {
				// DEBUG
				// console.log("Selective update for texture " + key);
				_updateTextures(key);
			}
		});

		clearTimeout(activeLoader);
		activeLoader = setTimeout(function () {
			_updateReflection();
			render();

			if (!blockedLoading) {
				document.querySelectorAll('.trophy-loader').forEach(function (item) {
					hide(item);
				})
			}
		}, 100);
	}


	// Resize
	// --------------------------------

	function resizeRenderer(sceneHeight) {
		// Resize renderer
		camera.aspect = window.innerWidth / sceneHeight;
		camera.updateProjectionMatrix();
		renderer.setSize(window.innerWidth, sceneHeight);
	}
	// Animating
	// --------------------------------

	function play() {
		started = true;
		camera.lookAt(controls.target);
		updateReflection();
		$(".loader").fadeOut(1000, 'swing');
	}

	function animate() {
		requestAnimationFrame( animate );

		// calc elapsed time since last loop

		now = Date.now();
		elapsed = now - then;

		// if enough time has elapsed, draw the next frame

		if (elapsed > fpsInterval) {

			// Get ready for next frame by setting then=now, but also adjust for your
			// specified fpsInterval not being a multiple of RAF's interval (16.7ms)
			then = now - (elapsed % fpsInterval);

			// Drawing
			if(inited) {
				if (started){

					if(dizzyCameraEnabled && debug === false) {
						dizzyCamera(camera);
					}
				}

				checkPerformance();

				if(controls) {
					controls.update();
				}
			}

			if(stats) {
				stats.update();
			}

			render();
		}
	}
	// Rendering
	// --------------------------------

	function render() {
		renderer.render(scene, camera);
	}

	// Quailty management
	// --------------------------------

	function checkPerformance() {
		currentFPS = gpu.getFPS();

		if( waitFrames == 0) {
			// Check FPS
			if (currentFPS < lowestFPS && lastConfigChange != -1) { 
				// fps too low
				if(debug === true) {
					console.log("Decrease quality");
				}
				if(!multiSearchOr(GPUInfo.renderer, hqGPUs)) {
					targetFPS = currentFPS; // then we should lock the FPS
					fpsInterval = 1000 / targetFPS;
				}
				addFlag = lastConfigChange = -1;
				updateQuality();
			} else if(currentFPS > targetFPS && lastConfigChange != 1) { 
				// fps too high
				if(debug === true) {
					console.log("Increase quality");
				}
				// Release FPS if device can do more
				if(multiSearchOr(GPUInfo.renderer, hqGPUs)) {
					targetFPS = 60;
					fpsInterval = 1000 / targetFPS;
				} else {
					targetFPS = 30;
					fpsInterval = 1000 / targetFPS;
				}
				addFlag = lastConfigChange = 1;
				updateQuality();
			} else { 
				//dont need to do anything
				if(debug === true) {
					console.log("Do nothing");
				}
				addFlag = 0;
			}
			waitFrames = waitTime;
		} else { 
			//keep waiting
			waitFrames--;
		}
	}

	function updateQuality() {
		// If have to change
		if(addFlag == -1) {
			//decrease quality

			// Meshes
			for(var i = 0; i < activeTrophy.a.objects.length; i++) {
				activeTrophy.a.objects[i].castShadow = false;
				activeTrophy.a.objects[i].receiveShadow = false;
			}
			roomMesh.receiveShadow = false;
			// Lights
			for(var i = 0; i < lights.length; i++) {
				lights[i].castShadow = false;
			}
		}
		else if(addFlag == 1) {
			//increase quality

			// Meshes
			for(var i = 0; i < activeTrophy.a.objects.length; i++) {
				activeTrophy.a.objects[i].castShadow = false;
				activeTrophy.a.objects[i].receiveShadow = false;
			}
			roomMesh.receiveShadow = false;
			// Lights
			for(var i = 0; i < lights.length; i++) {
				lights[i].castShadow = false;
			}
		}
	}


	// Reflection update
	// ------------------------------

	function updateReflection() {
		if(!reflectionUpdate) {
			reflectionUpdate = true;
			// Temporary hide the reflecting object, to clear out the render garbages
			// GL_INVALID_OPERATION : glDrawArrays: Source and destination textures of the draw are the same.
			for (var i = 0; i < activeTrophy.a.objects.length; i++) 
			{ 
				activeTrophy.a.objects[i].visible = false;
			}

			mirrorSphereCamera.update( renderer, scene );
			skySphereCamera.update( renderer, scene );

			for (var i = 0; i < activeTrophy.a.objects.length; i++) 
			{ 

				activeTrophy.a.objects[i].visible = true;
			}
			reflectionUpdate = false;
		}
	}

	// Dizzy camera animation
	// ------------------------------

	function dizzyCamera() {
		camera.movements.position.x += camera.movements.speed.x;
		camera.position.x = (camera.position.x + (Math.sin(camera.movements.position.x) * 0.002));

		camera.movements.position.y += camera.movements.speed.y;
		camera.position.y = (camera.position.y + (Math.sin(camera.movements.position.y) * 0.002));

		camera.movements.position.z += camera.movements.speed.z;
		camera.position.z = (camera.position.z + (Math.sin(camera.movements.position.z) * 0.002));
	};


	// Start
	// ------------------------------

	function start(params, container) {
		started = true;
		if(params.trophyType==='Pokal Gold') {params.trophyType = 'goldPokal';};
		if(params.trophyType==='Pokal World') params.trophyType = 'worldPokal';
		if(params.trophyType==='Goldmedaille') params.trophyType = 'goldMedal';
		if(params.trophyType==='Urkunde Papyrus') params.trophyType = 'certificatePapyrus';
		if(params.trophyType==='Las Vegas') params.trophyType = 'LasVegas';
		if(params.trophyType==='New York') params.trophyType = 'NewYork';
		if(params.trophyType==='Los Angeles') params.trophyType = 'LosAngeles';
		// Set default container
		if (container) {
			activeContainer = container;
		} else {
			throw "container not selected";
		}
		if(params.trophyType==='goldPokal'|| params.trophyType === 'worldPokal' || params.type==='certificatePapyrus'){
			params.offset = 80
			sceneHeight = window.innerHeight + parseInt(params.offset);
		}
		else{
			params.offset = 147
			sceneHeight = window.innerHeight - parseInt(params.offset);
		}

		// Start or restart
		if (inited === false) {
			_setVariables(params, function () {
				console.log("%cSTROPHY START", 'color: #2196f3');
				if(params.trophyType==='goldPokal'|| params.trophyType === 'worldPokal' || params.type==='certificatePapyrus'){
					params.offset = 80
					console.log(params.offset)
					sceneHeight = window.innerHeight + parseInt(params.offset);
				}
				if (WEBGL.isWebGLAvailable() === true) {
					try {
						// Init scene
						if (typeof scene == "undefined") {
							scene = new THREE.Scene();
						}

						// Init
						_init();
					}
					catch (err) {
						console.log(err);
					}
				} else {
					var warning = WEBGL.getWebGLErrorMessage();
					activeContainer.appendChild(warning);
				}
			});
		} else {
			console.log("%cSTROPHY RESTART", 'color: #2196f3');
			// Re-assign renderer canvas
			activeContainer.appendChild(renderer.domElement);
			// Resize renderer
			resizeRenderer(sceneHeight);

			// Do a swap
			swapModel(params);
		}
	};


	// Stop
	// ------------------------------

	function stop(callback) {
		console.log("%cSTROPHY STOP", 'color: #2196f3');
		started = false;

		// Destroy canvas
		var element = document.getElementById("WebGLContainer");
		if (element) {
			document.getElementById("WebGLContainer").parentNode.removeChild(element);
		}

		if (typeof callback === "function") {
			return callback();
		}
	};


	// Reset
	// ------------------------------

	function reset(params, container) {
		stop(function () {
			start(params, container);
		});
	}


	// Destroy
	// ------------------------------

	function destroy() {
		console.log("%cSTROPHY DESTROY", 'color: #2196f3');

		// Displose renderer
		renderer.dispose();
		renderer = null;

		scene = null;
		camera = null;

		debug = false;				// Debug mode
		started = false;			// Started
		inited = false;				// true = WebGL has been inited
		modelsReady = false;		// true = Models are ready!
		reflectionUpdate = false; 	// Reflection is updating
		blockedLoading = false;		// Flag for blocked model change (f.e. another loading in progress)

		// Iterate through all objects
		for (var i = 0; i < activeTrophy.a.objects.length; i++) {
			if (activeTrophy.a.objects[i] && typeof activeTrophy.a.objects[i].dispose === 'function') {
				activeTrophy.a.objects[i].dispose();
			}

			activeTrophy.a.objects[i] = null;
		}

		// Destroy canvas
		var element = document.getElementById("WebGLContainer");
		if (element) {
			document.getElementById("WebGLContainer").parentNode.removeChild(element);
		}
	};
	exports.texturesReady = texturesReady;
	exports.imageLoaders = imageLoaders;
	exports.loadSprite = loadSprite;
	exports._onWindowResize = _onWindowResize;
	exports._init = _init;
	exports._textureAssembler = _textureAssembler;
	exports._initAssets = _initAssets;
	exports._modelLoader = _modelLoader;

	exports.render = render;
	exports.swap = swapModel;
	exports.resize = resizeRenderer;
	exports.start = start;
	exports.stop = stop;
	exports.reset = reset;
	exports.destroy = destroy;

	// STATUS
	exports.started = started;
	exports.inited = inited;

	// FOR TEXTURE GENERATOR
	exports._updateTextures = _updateTextures;
})));
